import React from 'react';
import { motion } from 'framer-motion';
import { Book, CheckCircle, Sparkles, Tag } from 'lucide-react';
const features = ['Las Cinco Leyes Biológicas explicadas paso a paso', 'Ejemplos prácticos y casos reales', 'Ejercicios de autoconocimiento', 'Guía de interpretación de síntomas', 'Reflexiones para el crecimiento personal'];
export function PricingSection() {
  return <section id="pricing" className="py-24 bg-parchment-dark relative overflow-hidden" data-id="element-184">
      <div className="absolute -left-40 -top-40 w-96 h-96 bg-gold/5 rounded-full blur-3xl" data-id="element-185" />
      <div className="absolute -right-40 -bottom-40 w-96 h-96 bg-forest-light/5 rounded-full blur-3xl" data-id="element-186" />

      <div className="container mx-auto px-6 max-w-2xl relative z-10" data-id="element-187">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-14" data-id="element-188">
          <Sparkles className="w-10 h-10 text-gold mx-auto mb-5 opacity-80" data-id="element-189" />
          <h2 className="font-display text-4xl md:text-5xl text-forest-dark font-bold mb-4" data-id="element-190">
            Consigue tu Copia Hoy
          </h2>
          <p className="text-brown-light text-lg max-w-xl mx-auto" data-id="element-191">
            Invierte en tu bienestar y comienza hoy el camino hacia una vida más
            consciente
          </p>
          <div className="w-20 h-1 bg-gold mx-auto rounded-full mt-6" data-id="element-192" />
        </motion.div>

        {/* Single Pricing Card */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="bg-forest-dark rounded-2xl p-10 md:p-12 border border-gold/30 shadow-2xl shadow-black/15 relative overflow-hidden" data-id="element-193">
          {/* Discount badge */}
          <div className="absolute top-5 right-5 flex items-center gap-1.5 bg-gold text-forest-dark text-xs font-bold px-4 py-1.5 rounded-full uppercase tracking-wider" data-id="element-194">
            <Tag className="w-3.5 h-3.5" data-id="element-195" />
            Oferta Especial
          </div>

          <div className="text-center mb-8" data-id="element-196">
            <span className="text-sm font-medium text-gold-light uppercase tracking-widest" data-id="element-197">
              Edición Digital Completa
            </span>

            {/* Price with discount */}
            <div className="flex items-center justify-center gap-4 mt-5" data-id="element-198">
              <span className="text-white/60 text-2xl line-through font-display" data-id="element-199">
                $14.99
              </span>
              <div className="flex items-baseline gap-0.5" data-id="element-200">
                <span className="font-display text-6xl md:text-7xl text-gold font-bold" data-id="element-201">
                  $6
                </span>
                <span className="font-display text-3xl md:text-4xl text-gold font-bold" data-id="element-202">
                  .39
                </span>
              </div>
            </div>

            <p className="text-white text-sm mt-3" data-id="element-203">
              PDF + ePub — acceso inmediato tras la compra
            </p>

            <div className="inline-flex items-center gap-2 bg-gold/10 border border-gold/20 rounded-full px-4 py-1.5 mt-4" data-id="element-204">
              <span className="text-gold-light text-sm font-semibold" data-id="element-205">
                Ahorras más del 57%
              </span>
            </div>
          </div>

          <ul className="space-y-3.5 mb-10 max-w-sm mx-auto" data-id="element-206">
            {features.map((feature, idx) => <li key={idx} className="flex items-start gap-3 text-white" data-id="element-207">
                <CheckCircle className="w-5 h-5 text-gold shrink-0 mt-0.5" data-id="element-208" />
                <span data-id="element-209">{feature}</span>
              </li>)}
          </ul>

          <motion.a href="https://www.linochicastore.com/cart/40962739503153:1" target="_blank" rel="noopener noreferrer" onClick={() => {
          if (window.fbq) {
            window.fbq('track', 'AddToCart', {
              content_name: 'Del Dolor a la Conciencia',
              content_type: 'product',
              value: 6.39,
              currency: 'USD'
            });
          }
        }} whileHover={{
          scale: 1.03,
          boxShadow: '0 0 25px rgba(212, 175, 55, 0.45)'
        }} whileTap={{
          scale: 0.97
        }} className="w-full max-w-sm mx-auto bg-gradient-to-r from-gold-dark via-gold to-gold-dark text-forest-dark font-bold text-lg py-4 rounded-full flex items-center justify-center gap-3 shadow-lg shadow-gold/20 transition-all cursor-pointer no-underline" data-id="element-210">
            <Book className="w-5 h-5" data-id="element-211" />
            Comprar ahora por $6.39
          </motion.a>

          <p className="text-center text-white text-xs mt-5" data-id="element-212">
            Pago seguro · Descarga inmediata · Satisfacción garantizada
          </p>
        </motion.div>
      </div>
    </section>;
}